/**
 * 消息相关API接口
 */
import request from './utils/request'

/**
 * 查询消息列表
 * @param {Object} params - 查询参数
 * @param {string} params.isRead - 是否已读(0-已读 1-未读)
 * @param {string} params.type - 消息类型
 * @param {string} params.businessType - 业务类型
 * @param {number} params.pageNum - 页码
 * @param {number} params.pageSize - 每页数量
 * @returns {Promise} 消息列表
 */
export function getMessageList(params) {
  return request({
    url: '/web/portalSysMessage/list',
    method: 'get',
    params: params
  })
}

/**
 * 获取未读消息数量统计
 * @returns {Promise} 未读消息数量统计
 */
export function getUnreadMessageCount() {
  return request({
    url: '/web/portalSysMessage/unreadCount',
    method: 'get'
  })
}

/**
 * 根据用户阅读消息表ID获取消息详情
 * @param {number} readRecordId - 用户消息ID
 * @returns {Promise} 消息详情
 */
export function getUserMessageDetail(readRecordId) {
  return request({
    url: '/web/portalSysMessage/detail',
    method: 'get',
    params: { readRecordId }
  })
}

/**
 * 批量标记指定消息类型的所有未读消息为已读
 * @param {string} type - 消息类型（0-系统消息，1-业务消息，2-活动消息）
 * @returns {Promise} 操作结果
 */
export function markAllReadByType(type) {
  return request({
    url: '/web/portalSysMessage/markAllReadByType',
    method: 'post',
    params: { type }
  })
}

/**
 * 保存留言
 * @param {Object} data - 留言数据
 * @param {string} data.content - 留言内容
 * @returns {Promise} 保存结果
 */
export function saveLeaveMessage(data) {
  return request({
    url: '/web/suggestion/saveLeaveMessage',
    method: 'post',
    data: data
  })
}

